<template>
  <div class="fm-container">
    <div class="header-container">
      <div @click="onBackClick">
        <img class="back-arrow" src="@img/back-white.svg" />
      </div>

      <div style="position: absolute; left: 45%;">
        <p class="nav-title">{{ $t("app.home_ml") }}</p>
      </div>
    </div>

    <div class="pdf-container">
      <md-contract
        :fileUrl="fileUrl"
        :visible="contractVisable"
        :showBtns="true"
        @handleModal="close"
      ></md-contract>
    </div>
  </div>
</template>

<script>
import mdContract from "./contract.vue";
import NavgationBar from "@c/currency/NavigationBar";
import { Toast } from "vant";

export default {
  name: "catalog",
  components: {
    mdContract,
    NavgationBar
  },
  data() {
    return {
      fileUrl: "",
      showPdf: false,
      contractVisable: false
    };
  },
  created() {
    this.fileUrl =this.$route.params.url;
  },
  mounted() {
    Toast.loading({
      message: "加载中...",
      forbidClick: true
    });
    this.$nextTick(() => {
      this.contractVisable = true;
    });
  },
  methods: {
    onBackClick() {
      this.$router.go(-1);
    },
    close() {
      this.contractVisable = false;
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.fm-container {
  position: absoulte;
  width: 100%;
  height: 100%;
}

.header-container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  background: linear-gradient(0deg, #269ca8 0%, #6ac6ba 100%);
  height: 1.3rem;
  z-index: 999;
}

.pdf-container {
  margin-top: 1.3rem;
}

.back-arrow {
  width: 30px;
  height: 30px;
}
.nav-title{
 
 font-size: 18px;
 color: white;

}
</style>
